import { FlatFolderTreeItem } from "@zapier/bff";
import { FolderTreeItem } from "../useQueryFolderTree";

// Update folder tree item in tree recursively, returns back entire folder tree
export const updateFolderAttributeInTree = <V = string>(
  object: FolderTreeItem | FolderTreeItem[],
  folder: FolderTreeItem | FlatFolderTreeItem,
  attributeKey: string,
  attributeValue: V,
): FolderTreeItem[] | object => {
  if (Array.isArray(object)) {
    return object.map((o) =>
      updateFolderAttributeInTree(o, folder, attributeKey, attributeValue),
    );
  }

  if (String(object.id) === String(folder.id)) {
    return { ...object, [attributeKey]: attributeValue };
  }

  return {
    ...object,
    ...(object.children
      ? {
          children: updateFolderAttributeInTree(
            (object as any).children,
            folder,
            attributeKey,
            attributeValue,
          ),
        }
      : {}),
  };
};
